<template>
  <main id="main">
    <div class="columns is-gapless">
      <div class="column is-2">
        <SideMenu />
      </div>
      <div class="full_height column is-10 light_grey_bg content_column">
        <ManagementHeader :title="title" />

        <section class="section pt-0">
          <slot />
        </section>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  props: {
    title: String,
  },
  metaInfo() {
    return {
      title: this.title,
    };
  },
  watch: {
    '$page.props.flash.success': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$buefy.toast.open({
          message: newVal,
          type: 'is-success',
          position: 'is-top',
          duration: 5000,
        });
      }
    },
    '$page.props.flash.error': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$buefy.toast.open({
          message: newVal,
          type: 'is-danger',
          position: 'is-top',
          duration: 5000,
        });
      }
    },
  },
};
</script>
